import styled from 'styled-components';
import {TiScissors} from 'react-icons/ti';

export const Tiscissor = styled(TiScissors)`
  color: #078927;
`
